// extracted by mini-css-extract-plugin
export default {"container":"sa","hidden":"ta","column":"ua","headline":"va"};